'use client'

import { ChakraProvider } from '@chakra-ui/react'

import { type ColorModeProviderProps, LightMode } from './color-mode'
import { customSystem } from './theme'

export function WithChakraUI(props: ColorModeProviderProps) {
    return (
        <ChakraProvider value={customSystem}>
            <LightMode {...props} />
        </ChakraProvider>
    )
}
